import axios from 'axios';
import { isOffline, enterOffline } from '../../offline/connectivity';

// Obergrenze für jeden Request — im toten WLAN (verbunden, aber nichts kommt durch) hinge sonst alles
// unbegrenzt. Einzelne Aufrufe setzen kürzer (lokale Kopie als Fallback) oder länger per `timeout`.
const DEFAULT_TIMEOUT_MS = 15000;

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? 'https://api.av-enztal.de',
  withCredentials: true,
  timeout: DEFAULT_TIMEOUT_MS,
});

// Offline-Modus (siehe offline/connectivity.js): keine Requests — sofort ablehnen statt auf einen
// Timeout zu warten. Der Fehler hat keine `response` und wird daher überall wie ein Netzwerkfehler
// behandelt. Einzige Ausnahme: die explizite Verbindungsprobe (`offlineProbe: true`).
api.interceptors.request.use((config) => {
  if (isOffline() && !config.offlineProbe) {
    return Promise.reject(new axios.AxiosError('Offline-Modus', 'ERR_OFFLINE_MODE', config));
  }
  return config;
});

// Zentrale Offline-Erkennung: Fehler ohne HTTP-Antwort (Netzwerkfehler/Timeout) -> Offline-Modus.
// Ausnahmen: bewusst abgebrochene Requests und Hintergrund-Requests (`background: true`, z. B.
// Badge-Polling), auf die der Nutzer nicht wartet — die sollen den Modus nicht umschalten.
api.interceptors.response.use(undefined, (error) => {
  if (!error.response && !axios.isCancel(error) && !error.config?.background) {
    enterOffline();
  }
  return Promise.reject(error);
});

export default api;
